// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-J03","importantInfo":"styles_importantInfo__3GiGG"};